import PropTypes from "prop-types"
import Page from "components/Page"
import Apps from "components/Apps"
import { OGP } from "components/Meta"
import absoluteUrl from "next-absolute-url"

const Index = (props) => (
  <>
    <OGP meta={props.meta} />
    <Page>
      <Apps />
    </Page>
  </>
)

Index.propTypes = {
  meta: PropTypes.object.isRequired,
}

export const getServerSideProps = async ({ req }) => {
  const { protocol, host } = absoluteUrl(req, "localhost:3000")
  const meta = {
    title: "Apps | NobodySurf",
    description:
      "The Surf Video App for Surfers and Creators. NobodySurf is a place that honors and celebrates surf culture, community, and creators&lsquo; craft. Explore and find your favorite surfing clips and short films. Find more on the App Store.",
    image: "https://cdn.nobodysurf.com/com/img/NobodySurf_Cover_w1800.png",
    url: `${protocol}//${host}${req.originalUrl}`,
  }

  return {
    props: {
      meta: meta,
    },
  }
}

export default Index
